import { styled, TableCell } from "@mui/material"

const StyledTableCell = styled(TableCell)`
  border-right: 1px solid #e0e0e0;
  padding: 0 0.2em;
`

export default StyledTableCell
